module.exports = __webpack_public_path__ + "media/per/bghead-31e2d08d.png";